import { lazyLoadVideoSrc } from "../../../resources/js/helper/helper";

export default function initLazyLoadingVideos() {
  document.addEventListener("DOMContentLoaded", function () {
    // lazyload autoplay videos on pageload
    let lazyVideosAutoplay = [].slice.call(
      document.querySelectorAll("video.lazy[autoplay]")
    );

    lazyVideosAutoplay.forEach(function (lazyVideo) {
      lazyLoadVideoSrc(lazyVideo);
    });

    // lazyload videos on click
    let lazyVideos = [].slice.call(
      document.querySelectorAll("video.lazy:not([autoplay])")
    );

    lazyVideos.forEach(function (video) {
      video.addEventListener("click", function (e) {
        if (video.classList.contains("lazy")) {
          lazyLoadVideoSrc(video);

          video.addEventListener(
            "loadeddata",
            () => {
              video.play();
            },
            false
          );
        } else {
          video.paused ? video.play() : video.pause();
        }
      });
    });
  });
}
